
import { text } from "@fortawesome/fontawesome-svg-core";
import { useUserStore } from "../store/UserStore";

const subCities = [
  { id: "city_Airdrie", label: "Airdrie", key: 23460, children: [] },
  { id: "city_Brooks", label: "Brooks", key: 23461, children: [] },
  { id: "city_Calgary", label: "Calgary", key: 23462, children: [] },
  { id: "city_Camrose", label: "Camrose", key: 23463, children: [] },
  { id: "city_Canmore", label: "Canmore", key: 23479, children: [] },
  { id: "city_Chestermere", label: "Chestermere", key: 23464, children: [] },
  { id: "city_Cold Lake", label: "Cold Lake", key: 23465, children: [] },
  { id: "city_Edmonton", label: "Edmonton", key: 23466, children: [] },
  { id: "city_Fort Saskatchewan", label: "Fort Saskatchewan", key: 23467, children: [] },
  { id: "city_Grande Prairie", label: "Grande Prairie", key: 23468, children: [] },
  { id: "city_Lacombe", label: "Lacombe", key: 23469, children: [] },
  { id: "city_Leduc", label: "Leduc", key: 23470, children: [] },
  { id: "city_Lethbridge", label: "Lethbridge", key: 23471, children: [] },
  { id: "city_Lloydminster", label: "Lloydminster", key: 23472, children: [] },
  { id: "city_Medicine Hat", label: "Medicine Hat", key: 23473, children: [] },
  { id: "city_Red Deer", label: "Red Deer", key: 23474, children: [] },
  { id: "city_Spruce Grove", label: "Spruce Grove", key: 23475, children: [] },
  { id: "city_St. Albert", label: "St. Albert", key: 23476, children: [] },
  { id: "city_Wetaskiwin", label: "Wetaskiwin", key: 23477, children: [] },
  { id: "city_Duncan", label: "Duncan", key: 23428, children: [] },
  { id: "city_Salmon Arm", label: "Salmon Arm", key: 23429, children: [] },
  { id: "city_Westbank", label: "Westbank", key: 23436, children: [] },
  { id: "city_Tsawwassen First Nation", label: "Tsawwassen First Nation", key: 23430, children: [] },
  {
    id: "city_Sooke",
    label: "Sooke",
    key: 21150,
    children: [
      { label: "Phillips North", id: "subc_Phillips North", key: 22689 },
      { label: "Socke River East", id: "subc_Socke River East", key: 22690 },
      { label: "Saseenos", id: "subc_Saseenos", key: 22691 },
      { label: "North Sooke", id: "subc_North Sooke", key: 22692 },
      { label: "Grouse Nest", id: "subc_Grouse Nest", key: 22693 },
      { label: "Sunriver", id: "subc_Sunriver", key: 22694 },
      { label: "Otter Point", id: "subc_Otter Point", key: 22695 },
      { label: "Erinan", id: "subc_Erinan", key: 22696 },
      { label: "Broomhill", id: "subc_Broomhill", key: 22697 },
      { label: "Eastern Town Centre", id: "subc_Eastern Town Centre", key: 22698 },
      { label: "Town Centre", id: "subc_Town Centre", key: 22699 },
      {
        label: "Western Town Centre",
        id: "subc_Western Town Centre",
        key: 22700,
        children: [
          { label: "T'Sou-Ke 2 Nation", id: "subc_T'Sou-Ke 2 Nation", key: 22701 }
        ]
      },
      { label: "Whiffin Spit", id: "subc_Whiffin Spit", key: 22702 },
      { label: "Silver Spray", id: "subc_Silver Spray", key: 22703 },
      { label: "T'Sou-Ke 1 Nation", id: "subc_T'Sou-Ke 1 Nation", key: 22704 },
      { label: "Kaltasin", id: "subc_Kaltasin", key: 22705 }
    ]
  },
  {
    id: "city_Nanaimo",
    label: "Nanaimo",
    key: 21192,
    children: [
      { label: "Chase River", id: "subc_Chase River", key: 22565 },
      { label: "Diver Lake", id: "subc_Diver Lake", key: 21317 },
      { label: "Downtown Old City", id: "subc_Downtown Old City", key: 21324 },
      { label: "Hammond Bay", id: "subc_Hammond Bay", key: 21315 },
      { label: "Linley Valley", id: "subc_Linley Valley", key: 21316 },
      { label: "North Slope", id: "subc_North Slope", key: 21312 },
      { label: "Pleasant Valley", id: "subc_Pleasant Valley", key: 21313 },
      { label: "Rutherford", id: "subc_Rutherford", key: 21314 },
      { label: "Townsite", id: "subc_Townsite", key: 21321 },
      { label: "Westwood", id: "subc_Westwood", key: 21323 },
      { label: "Departure Bay", id: "subc_Departure Bay", key: 21318 },
      { label: "Dover", id: "subc_Dover", key: 21311 },
      { label: "Duke Point", id: "subc_Duke Point", key: 22566 },
      { label: "Harewood", id: "subc_Harewood", key: 22567 },
      { label: "Newcastle + Brechlin", id: "subc_Newcastle + Brechlin", key: 21320 },
      { label: "Northfield", id: "subc_Northfield", key: 21319 },
      { label: "Protection Island", id: "subc_Protection Island", key: 22568 },
      { label: "South End", id: "subc_South End", key: 22569 },
      { label: "University District", id: "subc_University District", key: 21322 }
    ]
  },
  {
    id: "city_Langford",
    label: "Langford",
    key: 21145,
    children: [
      { label: "Goldstream", id: "subc_Goldstream", key: 22506 },
      { label: "Bear Mountain", id: "subc_Bear Mountain", key: 22507 },
      { label: "Thetis Heights", id: "subc_Thetis Heights", key: 22508 },
      { label: "Florence Lake", id: "subc_Florence Lake", key: 22509 },
      { label: "Langford Lake", id: "subc_Langford Lake", key: 22510 },
      { label: "Langford Proper", id: "subc_Langford Proper", key: 22511 },
      { label: "Mill Hill", id: "subc_Mill Hill", key: 22512 },
      { label: "Atkins", id: "subc_Atkins", key: 22513 },
      { label: "Fairway", id: "subc_Fairway", key: 22514 },
      { label: "Jacklin", id: "subc_Jacklin", key: 22515 },
      { label: "Westhills", id: "subc_Westhills", key: 22516 },
      { label: "Glen Lake", id: "subc_Glen Lake", key: 22517 },
      { label: "Luxton", id: "subc_Luxton", key: 22518 },
      { label: "Walfred", id: "subc_Walfred", key: 22519 },
      { label: "Happy Valley", id: "subc_Happy Valley", key: 22520 },
      { label: "Olympic View", id: "subc_Olympic View", key: 22521 }
    ]
  },
  {
    id: "city_Saanich (North)",
    label: "Saanich (North)",
    key: 21146,
    children: [
      { label: "Deep Cove", id: "subc_Deep Cove", key: 22340 },
      { label: "Cloake Hill & Horth Hill", id: "subc_Cloake Hill & Horth Hill", key: 22341 },
      { label: "Central Area North", id: "subc_Central Area North", key: 22342 },
      { label: "Curteis Point & McDonald Park", id: "subc_Curteis Point & McDonald Park", key: 22343 },
      { label: "Tseycum Nation", id: "subc_Tseycum Nation", key: 22344 },
      { label: "Airport", id: "subc_Airport", key: 22345 },
      { label: "Town of Sidney", id: "subc_Town of Sidney", key: 22346 },
      { label: "Central Area South", id: "subc_Central Area South", key: 22347 },
      { label: "Ardmore", id: "subc_Ardmore", key: 22348 },
      { label: "Pauquachin Nation", id: "subc_Pauquachin Nation", key: 22349 },
      { label: "Dean Park", id: "subc_Dean Park", key: 22350 },
      { label: "South East Quadrant", id: "subc_South East Quadrant", key: 22351 }
    ]
  },
  {
    id: "city_Saanich (Central)",
    label: "Saanich (Central)",
    key: 21141,
    children: [
      { label: "Inlet", id: "subc_Inlet", key: 22280 },
      { label: "Saanichton", id: "subc_Saanichton", key: 21310 },
      { label: "Hawthorne", id: "subc_Hawthorne", key: 22281 },
      { label: "Island View", id: "subc_Island View", key: 22282 },
      { label: "Keating", id: "subc_Keating", key: 22283 },
      { label: "Brentwood Bay", id: "subc_Brentwood Bay", key: 22284 },
      { label: "Oldfield", id: "subc_Oldfield", key: 22286 },
      { label: "Tanner", id: "subc_Tanner", key: 22285 },
      { label: "Martindale", id: "subc_Martindale", key: 22287 }
    ]
  },
  { id: "city_Campbell River", label: "Campbell River", key: 21881, children: [] },
  { id: "city_Duncan_2", label: "Duncan", key: 21880, children: [] },
  { id: "city_Kamloops", label: "Kamloops", key: 21878, children: [] },
  { id: "city_Lake Country", label: "Lake Country", key: 21877, children: [] },
  { id: "city_Revelstoke", label: "Revelstoke", key: 21860, children: [] },
  {
    id: "city_Chiliwack",
    label: "Chiliwack",
    key: 3610,
    children: [
      { label: "Yarrow", id: "subc_Yarrow", key: 21846 },
      { label: "Greendale", id: "subc_Greendale", key: 21847 },
      { label: "Cultus Lake", id: "subc_Cultus Lake", key: 23102 },
      { label: "Cattermole", id: "subc_Cattermole", key: 21848 },
      { label: "Vedder", id: "subc_Vedder", key: 21849 },
      { label: "Village West", id: "subc_Village West", key: 21851 },
      { label: "Chilliwack Mountain", id: "subc_Chilliwack Mountain", key: 21850 },
      { label: "Sardis", id: "subc_Sardis", key: 21355 },
      { label: "Promontory", id: "subc_Promontory", key: 21852 },
      { label: "Ryder Lake", id: "subc_Ryder Lake", key: 21853 },
      { label: "Eastern Hillsides", id: "subc_Eastern Hillsides", key: 21854 },
      { label: "Chilliwack Proper", id: "subc_Chilliwack Proper", key: 21855 },
      { label: "Fairfield", id: "subc_Fairfield", key: 21856 },
      { label: "Little Mountain", id: "subc_Little Mountain", key: 21857 },
      { label: "Rosedale", id: "subc_Rosedale", key: 21858 }
    ]
  },
  { id: "city_Marysville", label: "Marysville", key: 21591, children: [] },
  { id: "city_Parksville", label: "Parksville", key: 21592, children: [] },
  { id: "city_Chase River_2", label: "Chase River", key: 21327, children: [] },
  { id: "city_Harewood_2", label: "Harewood", key: 21326, children: [] },
  { id: "city_Peachland", label: "Peachland", key: 21228, children: [] },
  { id: "city_South End_2", label: "South End", key: 21325, children: [] },
  {
    id: "city_Penticton",
    label: "Penticton",
    key: 21183,
    children: [
      { label: "Apex Mountain", id: "subc_Apex Mountain", key: 21225 },
      { label: "Carmi", id: "subc_Carmi", key: 21226 },
      { label: "Columbia / Duncan", id: "subc_Columbia / Duncan", key: 21218 },
      { label: "Husula / West Bench / Sage Mesa", id: "subc_Husula / West Bench / Sage Mesa", key: 21219 },
      { label: "K-Streets", id: "subc_K-Streets", key: 21221 },
      { label: "Main North", id: "subc_Main North", key: 21220 },
      { label: "Main South", id: "subc_Main South", key: 21222 },
      { label: "Uplands / Redlands", id: "subc_Uplands / Redlands", key: 21223 },
      { label: "Wiltse / Valleyview", id: "subc_Wiltse / Valleyview", key: 21224 }
    ]
  },
  {
    id: "city_Princeton",
    label: "Princeton",
    key: 21187,
    children: [
      { label: "1st Bench", id: "subc_1st Bench", key: 21205 },
      { label: "2nd Bench", id: "subc_2nd Bench", key: 21206 },
      { label: "3rd Bench", id: "subc_3rd Bench", key: 21207 },
      { label: "Airport", id: "subc_Airport", key: 21208 },
      { label: "Allison Flats", id: "subc_Allison Flats", key: 21209 },
      { label: "Deerview Estates", id: "subc_Deerview Estates", key: 21210 },
      { label: "Downtown Core", id: "subc_Downtown Core", key: 21211 },
      { label: "Downtown North", id: "subc_Downtown North", key: 21212 },
      { label: "East Princeton", id: "subc_East Princeton", key: 21213 },
      { label: "Industrial Park", id: "subc_Industrial Park", key: 21214 },
      { label: "Pines Park", id: "subc_Pines Park", key: 21215 },
      { label: "Westridge Heights", id: "subc_Westridge Heights", key: 21216 }
    ]
  },
  {
    id: "city_Kelowna",
    label: "Kelowna",
    key: 21185,
    children: [
      { label: "South Pandosy", id: "subc_South Pandosy", key: 23437 },
      { label: "McKinley Beach", id: "subc_McKinley Beach", key: 23438 },
      { label: "Downtown", id: "subc_Downtown", key: 23439 },
      { label: "Capri-Landmark", id: "subc_Capri-Landmark", key: 21227 },
      { label: "Dilworth", id: "subc_Dilworth", key: 21201 },
      { label: "Lake Country", id: "subc_Lake Country", key: 21194 },
      { label: "Lower Mission", id: "subc_Lower Mission", key: 21195 },
      { label: "Upper Mission", id: "subc_Upper Mission", key: 21196 },
      { label: "Lakeview Heights", id: "subc_Lakeview Heights", key: 21197 },
      { label: "South East Kelowna", id: "subc_South East Kelowna", key: 21198 },
      { label: "Rutland", id: "subc_Rutland", key: 21203 },
      { label: "North Glenmore", id: "subc_North Glenmore", key: 21199 },
      { label: "Glenmore", id: "subc_Glenmore", key: 21200 },
      { label: "Ellison", id: "subc_Ellison", key: 21204 },
      { label: "Mission Hill", id: "subc_Mission Hill", key: 21202 },
      { label: "McKinley Landing", id: "subc_McKinley Landing", key: 21217 }
    ]
  },
  { id: "city_Vernon", label: "Vernon", key: 21184, children: [] },
  { id: "city_West Kelowna", label: "West Kelowna", key: 21186, children: [] },
  { id: "city_Salt Spring Island", label: "Salt Spring Island", key: 21191, children: [] },
  {
    id: "city_Osoyoos",
    label: "Osoyoos",
    key: 21188,
    children: [
      { label: "Osoyoos", id: "subc_Osoyoos", key: 21193 }
    ]
  },
  { id: "city_View Royal", label: "View Royal", key: 21190, children: [] },
  {
    id: "city_Colwood",
    label: "Colwood",
    key: 21142,
    children: [
      { label: "CFB Esquimalt - Colwood", id: "subc_CFB Esquimalt - Colwood", key: 21967 },
      { label: "Colwood Corners", id: "subc_Colwood Corners", key: 21958 },
      { label: "Colwood Lake", id: "subc_Colwood Lake", key: 21961 },
      { label: "Hatley Park", id: "subc_Hatley Park", key: 21962 },
      { label: "Latoria", id: "subc_Latoria", key: 21966 },
      { label: "Royal Bay", id: "subc_Royal Bay", key: 21883 },
      { label: "Royal Roads", id: "subc_Royal Roads", key: 21960 },
      { label: "Seaside", id: "subc_Seaside", key: 21959 },
      { label: "Triangle Mountain", id: "subc_Triangle Mountain", key: 21964 },
      { label: "Wishart North", id: "subc_Wishart North", key: 21965 },
      { label: "Wishart South", id: "subc_Wishart South", key: 21963 },
      { label: "The Beachlands", id: "subc_The Beachlands", key: 21968 }
    ]
  },
  { id: "city_Sidney", label: "Sidney", key: 21149, children: [] },
  {
    id: "city_Saanich",
    label: "Saanich",
    key: 21148,
    children: [
      { label: "Tillicum", id: "subc_Tillicum", key: 23128 },
      { label: "Shelbourne", id: "subc_Shelbourne", key: 21882 },
      { label: "Saanich Core", id: "subc_Saanich Core", key: 23126 },
      { label: "Rural Saanich", id: "subc_Rural Saanich", key: 23121 },
      { label: "Royal Oak", id: "subc_Royal Oak", key: 23122 },
      { label: "Quadra", id: "subc_Quadra", key: 23130 },
      { label: "North Quadra", id: "subc_North Quadra", key: 23124 },
      { label: "Gordon Head", id: "subc_Gordon Head", key: 23129 },
      { label: "Cordova Bay", id: "subc_Cordova Bay", key: 23120 },
      { label: "Carey", id: "subc_Carey", key: 23125 },
      { label: "Cadboro Bay", id: "subc_Cadboro Bay", key: 23127 },
      { label: "Blenkinsop", id: "subc_Blenkinsop", key: 23123 }
    ]
  },
  { id: "city_Oak Bay", label: "Oak Bay", key: 21147, children: [] },
  { id: "city_Highlands", label: "Highlands", key: 21144, children: [] },
  {
    id: "city_Esquimalt",
    label: "Esquimalt",
    key: 21143,
    children: [
      { label: "Esquimalt", id: "subc_Esquimalt", key: 21236 },
      { label: "Gorge Vale", id: "subc_Gorge Vale", key: 21237 },
      { label: "Kinsmen Park", id: "subc_Kinsmen Park", key: 21238 },
      { label: "Old Esquimalt", id: "subc_Old Esquimalt", key: 21239 },
      { label: "Rockheights", id: "subc_Rockheights", key: 21240 },
      { label: "Saxe Point", id: "subc_Saxe Point", key: 21241 }
    ]
  },
  {
    id: "city_Squamish",
    label: "Squamish",
    key: 2894,
    children: [
      { label: "Downtown Squamish", id: "subc_Downtown Squamish", key: 21593 },
      { label: "Paradise Valley", id: "subc_Paradise Valley", key: 20618 },
      { label: "Tantalus", id: "subc_Tantalus", key: 20619 },
      { label: "Brackendale", id: "subc_Brackendale", key: 20620 },
      { label: "Garibaldi Estates", id: "subc_Garibaldi Estates", key: 20621 },
      { label: "Brennan Park/ Loggers Lane", id: "subc_Brennan Park/ Loggers Lane", key: 20622 },
      { label: "Valleycliffe & Hospital Hill", id: "subc_Valleycliffe & Hospital Hill", key: 20623 },
      { label: "Squamish South", id: "subc_Squamish South", key: 20624 },
      { label: "North Yards", id: "subc_North Yards", key: 20625 },
      { label: "Dentville", id: "subc_Dentville", key: 20626 }
    ]
  },
  {
    id: "city_Maple Ridge",
    label: "Maple Ridge",
    key: 2888,
    children: [
      { label: "Albion", id: "subc_Albion", key: 19067 },
      { label: "Allco", id: "subc_Allco", key: 19068 },
      { label: "Alouette", id: "subc_Alouette", key: 19069 },
      { label: "Blue Mountain", id: "subc_Blue Mountain", key: 19070 },
      { label: "Central Maple Ridge", id: "subc_Central Maple Ridge", key: 19071 },
      { label: "Cottonwood", id: "subc_Cottonwood", key: 19072 },
      { label: "East Maple Ridge", id: "subc_East Maple Ridge", key: 19073 },
      { label: "Hammond", id: "subc_Hammond", key: 19074 },
      { label: "Rothsay", id: "subc_Rothsay", key: 19075 },
      { label: "Ruskin", id: "subc_Ruskin", key: 19076 },
      { label: "Silver Valley", id: "subc_Silver Valley", key: 19077 },
      { label: "Smith", id: "subc_Smith", key: 19078 },
      { label: "South Alouette", id: "subc_South Alouette", key: 19079 },
      { label: "Spilsbury", id: "subc_Spilsbury", key: 19080 },
      { label: "Thornhill", id: "subc_Thornhill", key: 19081 },
      { label: "Town Centre", id: "subc_Town Centre", key: 19082 },
      { label: "Websters Corners", id: "subc_Websters Corners", key: 19083 },
      { label: "West Maple Ridge", id: "subc_West Maple Ridge", key: 19084 },
      { label: "Whispering Falls", id: "subc_Whispering Falls", key: 19085 },
      { label: "Whonnock", id: "subc_Whonnock", key: 19086 },
      { label: "Yennadon", id: "subc_Yennadon", key: 19087 }
    ]
  },
  {
    id: "city_Surrey",
    label: "Surrey",
    key: 2887,
    children: [
      { label: "Cloverdale", id: "subc_Cloverdale", key: 11164 },
      { label: "Fleetwood", id: "subc_Fleetwood", key: 11161 },
      { label: "Guildford", id: "subc_Guildford", key: 11162 },
      { label: "Newton", id: "subc_Newton", key: 11165 },
      { label: "South Surrey", id: "subc_South Surrey", key: 11159 },
      { label: "Whalley", id: "subc_Whalley", key: 11163 }
    ]
  },
  {
    id: "city_Langley (Township)",
    label: "Langley (Township)",
    key: 2879,
    children: [
      { label: "Walnut Grove", id: "subc_Walnut Grove", key: 16677 },
      { label: "Brookswood / Fernridge", id: "subc_Brookswood / Fernridge", key: 16671 },
      { label: "Gloucester", id: "subc_Gloucester", key: 16673 },
      { label: "Murrayville", id: "subc_Murrayville", key: 16674 },
      { label: "Northwest Langley", id: "subc_Northwest Langley", key: 16675 },
      { label: "Rural", id: "subc_Rural", key: 16676 },
      { label: "Willoughby Hts", id: "subc_Willoughby Hts", key: 16678 },
      { label: "Willowbrook", id: "subc_Willowbrook", key: 16679 },
      { label: "Aldergrove", id: "subc_Aldergrove", key: 16670 },
      { label: "Fort Langley", id: "subc_Fort Langley", key: 16672 }
    ]
  },
  {
    id: "city_Langley (City)",
    label: "Langley (City)",
    key: 3556,
    children: [
      { label: "Alice Brown", id: "subc_Alice Brown", key: 16685 },
      { label: "Douglas", id: "subc_Douglas", key: 16682 },
      { label: "Blacklock", id: "subc_Blacklock", key: 16684 },
      { label: "Nicomekl", id: "subc_Nicomekl", key: 16681 },
      { label: "Simonds", id: "subc_Simonds", key: 16683 },
      { label: "Uplands", id: "subc_Uplands", key: 16686 }
    ]
  },
  {
    id: "city_Delta",
    label: "Delta",
    key: 2898,
    children: [
      { label: "Boundary Bay", id: "subc_Boundary Bay", key: 16698 },
      { label: "Ladner", id: "subc_Ladner", key: 16695 },
      { label: "North Delta", id: "subc_North Delta", key: 16696 },
      { label: "Tsawwassen", id: "subc_Tsawwassen", key: 16697 }
    ]
  },
  {
    id: "city_Abbotsford",
    label: "Abbotsford",
    key: 2876,
    children: [
      { label: "Bradner", id: "subc_Bradner", key: 16688 },
      { label: "Abbotsford Centre", id: "subc_Abbotsford Centre", key: 21884 },
      { label: "Aberdeen", id: "subc_Aberdeen", key: 16687 },
      { label: "Clayburn", id: "subc_Clayburn", key: 16689 },
      { label: "District of Matsqui", id: "subc_District of Matsqui", key: 16691 },
      { label: "Huntingdon", id: "subc_Huntingdon", key: 16692 },
      { label: "Kilgard", id: "subc_Kilgard", key: 16693 },
      { label: "Mount Lehman", id: "subc_Mount Lehman", key: 16694 },
      { label: "Clearbrook", id: "subc_Clearbrook", key: 16690 }
    ]
  },
  { id: "city_White Rock", label: "White Rock", key: 2897, children: [] },
  {
    id: "city_Mission",
    label: "Mission",
    key: 3609,
    children: [
      { label: "Cedar Valley", id: "subc_Cedar Valley", key: 16710 },
      { label: "Ferndale", id: "subc_Ferndale", key: 16705 },
      { label: "Fraser Corridor", id: "subc_Fraser Corridor", key: 16708 },
      { label: "Hatzic", id: "subc_Hatzic", key: 16706 },
      { label: "Israel Bench", id: "subc_Israel Bench", key: 16709 },
      { label: "Keystone", id: "subc_Keystone", key: 16701 },
      { label: "Mission Core", id: "subc_Mission Core", key: 16707 },
      { label: "Silver Creek", id: "subc_Silver Creek", key: 16704 },
      { label: "Silverdale", id: "subc_Silverdale", key: 16703 },
      { label: "Silverhill", id: "subc_Silverhill", key: 16702 },
      { label: "Stave Falls", id: "subc_Stave Falls", key: 16699 },
      { label: "Steelhead", id: "subc_Steelhead", key: 16700 }
    ]
  },
  { label: "North Vancouver (City)", id: "city_North Vancouver (City)", key: 2949, children: [] },
  {
    label: "North Vancouver (District)",
    id: "city_North Vancouver (District)",
    key: 2950, children: [],
  },
  {
    id: "city_Vancouver",
    label: "Vancouver",
    key: 2895,
    children: [
      { label: "Van E (Grandview-Woodland)", id: "subc_Van E (Grandview-Woodland)", key: 16718 },
      { label: "Van E (Hastings-Sunrise)", id: "subc_Van E (Hastings-Sunrise)", key: 16719 },
      { label: "Van E (Kensington-Cedar Cottage)", id: "subc_Van E (Kensington-Cedar Cottage)", key: 16720 },
      { label: "Van E (Killarney)", id: "subc_Van E (Killarney)", key: 16722 },
      { label: "Van E (Mount Pleasant)", id: "subc_Van E (Mount Pleasant)", key: 16725 },
      { label: "Van E (Renfrew-Collingwood)", id: "subc_Van E (Renfrew-Collingwood)", key: 16727 },
      { label: "Van E (Strathcona)", id: "subc_Van E (Strathcona)", key: 16731 },
      { label: "Van E (Sunset)", id: "subc_Van E (Sunset)", key: 16732 },
      { label: "Van E (Victoria-Fraserview)", id: "subc_Van E (Victoria-Fraserview)", key: 16733 },
      { label: "Van E / W (Riley Park - Little Mountain)", id: "subc_Van E / W (Riley Park - Little Mountain)", key: 16728 },
      { label: "Van W (Arbutus Ridge)", id: "subc_Van W (Arbutus Ridge)", key: 16714 },
      { label: "Van W (Dunbar-Southlands)", id: "subc_Van W (Dunbar-Southlands)", key: 16716 },
      { label: "Van W (Fairview)", id: "subc_Van W (Fairview)", key: 16717 },
      { label: "Van W (Kerrisdale)", id: "subc_Van W (Kerrisdale)", key: 16721 },
      { label: "Van W (Kitsilano)", id: "subc_Van W (Kitsilano)", key: 16723 },
      { label: "Van W (Marpole)", id: "subc_Van W (Marpole)", key: 16724 },
      { label: "Van W (Musqueam)", id: "subc_Van W (Musqueam)", key: 25870 },
      { label: "Van W (Oakridge)", id: "subc_Van W (Oakridge)", key: 16726 },
      { label: "Van W (Sen̓áḵw)", id: "subc_Van W (Sen̓áḵw)", key: 25871 },
      { label: "Van W (Shaughnessy)", id: "subc_Van W (Shaughnessy)", key: 16729 },
      { label: "Van W (South Cambie)", id: "subc_Van W (South Cambie)", key: 16730 },
      { label: "Van W (West Point Grey)", id: "subc_Van W (West Point Grey)", key: 16735 },
      { label: "Van Downtown", id: "subc_Van Downtown", key: 16715 },
      { label: "Van Downtown (West End)", id: "subc_Van Downtown (West End)", key: 16734 },
      { label: "University Endowment Lands", id: "subc_University Endowment Lands", key: 21171 }
    ]
  },
  {
    id: "city_University Endowment Lands",
    label: "University Endowment Lands",
    key: 3557,
    children: [
      { label: "Wesbrook Village", id: "subc_Wesbrook Village", key: 21879 }
    ]
  },
  {
    id: "city_Burnaby",
    label: "Burnaby",
    key: 2873,
    children: [
      { label: "Lake City", id: "subc_Lake City", key: 16743 },
      { label: "BainBridge", id: "subc_BainBridge", key: 16753 },
      { label: "Big Bend", id: "subc_Big Bend", key: 16752 },
      { label: "Brentwood", id: "subc_Brentwood", key: 16751 },
      { label: "Broadview", id: "subc_Broadview", key: 16750 },
      { label: "Capitol Hill", id: "subc_Capitol Hill", key: 16749 },
      { label: "Central Administrative", id: "subc_Central Administrative", key: 16748 },
      { label: "Discovery Place", id: "subc_Discovery Place", key: 16747 },
      { label: "Edmonds", id: "subc_Edmonds", key: 16746 },
      { label: "George Derby", id: "subc_George Derby", key: 16745 },
      { label: "Hastings", id: "subc_Hastings", key: 16744 },
      { label: "Lougheed", id: "subc_Lougheed", key: 16742 },
      { label: "Metrotown", id: "subc_Metrotown", key: 16741 },
      { label: "Montecito", id: "subc_Montecito", key: 16740 },
      { label: "Rayside", id: "subc_Rayside", key: 16739 },
      { label: "Royal Oak", id: "subc_Royal Oak", key: 16738 },
      { label: "SFU", id: "subc_SFU", key: 16737 },
      { label: "Sixth Street", id: "subc_Sixth Street", key: 16736 }
    ]
  },
  {
    id: "city_Richmond",
    label: "Richmond",
    key: 2877,
    children: [
      { label: "Blundell", id: "subc_Blundell", key: 18833 },
      { label: "Bridgeport", id: "subc_Bridgeport", key: 18834 },
      { label: "Broadmoor", id: "subc_Broadmoor", key: 18835 },
      { label: "City Centre", id: "subc_City Centre", key: 18836 },
      { label: "East Cambie", id: "subc_East Cambie", key: 18837 },
      { label: "East Richmond", id: "subc_East Richmond", key: 18838 },
      { label: "Hamilton", id: "subc_Hamilton", key: 18839 },
      { label: "Sea Island", id: "subc_Sea Island", key: 19089 },
      { label: "Shellmont", id: "subc_Shellmont", key: 18840 },
      { label: "Steveston", id: "subc_Steveston", key: 18841 },
      { label: "Thompson", id: "subc_Thompson", key: 18842 },
      { label: "West Cambie", id: "subc_West Cambie", key: 18843 },
      { label: "Broadmoor/Shellmont/Gilmore", id: "subc_Broadmoor/Shellmont/Gilmore", key: 18062 },
      { label: "City Centre/Brighouse", id: "subc_City Centre/Brighouse", key: 18063 },
      { label: "Steveston", id: "subc_Steveston_2", key: 18064 },
      { label: "Thompson/Seafair/Blundell", id: "subc_Thompson/Seafair/Blundell", key: 18065 }
    ]
  },
  {
    id: "city_Coquitlam",
    label: "Coquitlam",
    key: 2874,
    children: [
      { label: "Burke Mountain (Upper Hyde Creek)", id: "subc_Burke Mountain (Upper Hyde Creek)", key: 17221 },
      { label: "City Centre (C)", id: "subc_City Centre (C)", key: 21101 },
      { label: "Burke Mountain (Partington Creek)", id: "subc_Burke Mountain (Partington Creek)", key: 17224 },
      { label: "Burke Mountain (Smiling Creek)", id: "subc_Burke Mountain (Smiling Creek)", key: 17223 },
      { label: "Mayfair/Pacific Reach", id: "subc_Mayfair/Pacific Reach", key: 17222 },
      { label: "Northeast Coquitlam", id: "subc_Northeast Coquitlam", key: 17220 },
      { label: "Burquitlam", id: "subc_Burquitlam", key: 16754 },
      { label: "Hockaday Nestor", id: "subc_Hockaday Nestor", key: 17219 },
      { label: "Burke Mountain (Lower Hyde Park)", id: "subc_Burke Mountain (Lower Hyde Park)", key: 16755 },
      { label: "Ranch Park", id: "subc_Ranch Park", key: 16756 },
      { label: "River Springs", id: "subc_River Springs", key: 16757 },
      { label: "Oxford Heights (C)", id: "subc_Oxford Heights (C)", key: 16758 },
      { label: "Maillardville", id: "subc_Maillardville", key: 16759 },
      { label: "Austin Heights", id: "subc_Austin Heights", key: 16760 },
      { label: "Chineside", id: "subc_Chineside", key: 16761 },
      { label: "Birchland Manor (C)", id: "subc_Birchland Manor (C)", key: 16762 },
      { label: "Coquitlam Town Centre", id: "subc_Coquitlam Town Centre", key: 16763 },
      { label: "Westwood Plateau", id: "subc_Westwood Plateau", key: 16764 },
      { label: "Eagle Ridge", id: "subc_Eagle Ridge", key: 16765 },
      { label: "Mary Hill", id: "subc_Mary Hill", key: 16766 }
    ]
  },
  {
    id: "city_Port Moody",
    label: "Port Moody",
    key: 2893,
    children: [
      { label: "April Road", id: "subc_April Road", key: 19050 },
      { label: "College Park", id: "subc_College Park", key: 19061 },
      { label: "Coronation Park", id: "subc_Coronation Park", key: 19058 },
      { label: "Glenayre", id: "subc_Glenayre", key: 19063 },
      { label: "Harbour Heights", id: "subc_Harbour Heights", key: 19060 },
      { label: "Heritage Mountain", id: "subc_Heritage Mountain", key: 19054 },
      { label: "Heritage Woods", id: "subc_Heritage Woods", key: 19053 },
      { label: "Inlet Centre", id: "subc_Inlet Centre", key: 19057 },
      { label: "Ioco", id: "subc_Ioco", key: 19049 },
      { label: "Moody Centre", id: "subc_Moody Centre", key: 19059 },
      { label: "Mountain Meadows", id: "subc_Mountain Meadows", key: 19056 },
      { label: "Noon Creeks", id: "subc_Noon Creeks", key: 19055 },
      { label: "Pleasantside", id: "subc_Pleasantside", key: 19052 },
      { label: "Seaview", id: "subc_Seaview", key: 19062 },
      { label: "Twin Creeks", id: "subc_Twin Creeks", key: 19051 }
    ]
  },
  {
    id: "city_Port Coquitlam",
    label: "Port Coquitlam",
    key: 2892,
    children: [
      { label: "Birchland Manor", id: "subc_Birchland Manor", key: 19794 },
      { label: "Central Pt Coquitlam", id: "subc_Central Pt Coquitlam", key: 19796 },
      { label: "Citadel PQ", id: "subc_Citadel PQ", key: 19798 },
      { label: "Glenwood PQ", id: "subc_Glenwood PQ", key: 19793 },
      { label: "Lincoln Park PQ", id: "subc_Lincoln Park PQ", key: 19791 },
      { label: "Lower Mary Hill", id: "subc_Lower Mary Hill", key: 19797 },
      { label: "Oxford Heights", id: "subc_Oxford Heights", key: 19790 },
      { label: "Riverwood", id: "subc_Riverwood", key: 19795 },
      { label: "Woodland Acres PQ", id: "subc_Woodland Acres PQ", key: 19792 }
    ]
  },
  {
    id: "city_New Westminster",
    label: "New Westminster",
    key: 2889,
    children: [
      { label: "Queensborough", id: "subc_Queensborough", key: 17522 },
      { label: "Connaught Heights", id: "subc_Connaught Heights", key: 17523 },
      { label: "West End", id: "subc_West End", key: 17524 },
      { label: "Kelvin", id: "subc_Kelvin", key: 17525 },
      { label: "Brow of the Hill", id: "subc_Brow of the Hill", key: 17526 },
      { label: "Glenbrooke North", id: "subc_Glenbrooke North", key: 17527 },
      { label: "Queen's Park", id: "subc_Queen's Park", key: 17528 },
      { label: "Victory Heights (Includes Massey Heights)", id: "subc_Victory Heights (Includes Massey Heights)", key: 17529 },
      { label: "Sapperton", id: "subc_Sapperton", key: 17530 },
      { label: "North Arm South", id: "subc_North Arm South", key: 17531 },
      { label: "North Arm North", id: "subc_North Arm North", key: 17532 },
      { label: "Uptown", id: "subc_Uptown", key: 17533 },
      { label: "Downtown", id: "subc_Downtown", key: 17534 },
      { label: "Glenbrooke South", id: "subc_Glenbrooke South", key: 17535 },
      { label: "Brunette Creek", id: "subc_Brunette Creek", key: 17536 }
    ]
  },
  {
    id: "city_West Vancouver",
    label: "West Vancouver",
    key: 2896,
    children: [
      { label: "Lions Gate", id: "subc_Lions Gate", key: 21859 },
      { label: "Altamont", id: "subc_Altamont", key: 18494 },
      { label: "Ambleside", id: "subc_Ambleside", key: 18495 },
      { label: "Bayridge", id: "subc_Bayridge", key: 18496 },
      { label: "British Properties", id: "subc_British Properties", key: 18497 },
      { label: "Caulfeild", id: "subc_Caulfeild", key: 18498 },
      { label: "Cedardale", id: "subc_Cedardale", key: 18499 },
      { label: "Dundarave", id: "subc_Dundarave", key: 18500 },
      { label: "Eagle Harbour", id: "subc_Eagle Harbour", key: 18501 },
      { label: "Gleneagles", id: "subc_Gleneagles", key: 18502 },
      { label: "Horseshoe Bay", id: "subc_Horseshoe Bay", key: 18503 },
      { label: "Sentinel Hill", id: "subc_Sentinel Hill", key: 18504 },
      { label: "Westmount", id: "subc_Westmount", key: 18505 },
      { label: "Whytecliff", id: "subc_Whytecliff", key: 18506 }
    ]
  },
  {
    id: "city_Victoria",
    label: "Victoria",
    key: 11257,
    children: [
      { label: "Burnside", id: "subc_Burnside", key: 11278 },
      { label: "Downtown", id: "subc_Downtown", key: 11279 },
      { label: "Fairfield", id: "subc_Fairfield", key: 11280 },
      { label: "Fernwood", id: "subc_Fernwood", key: 11281 },
      { label: "Gonzales", id: "subc_Gonzales", key: 11282 },
      { label: "Harris Green", id: "subc_Harris Green", key: 11283 },
      { label: "Hillside Quadra", id: "subc_Hillside Quadra", key: 11284 },
      { label: "James Bay", id: "subc_James Bay", key: 11285 },
      { label: "Jubilee", id: "subc_Jubilee", key: 11286 },
      { label: "North Park", id: "subc_North Park", key: 11287 },
      { label: "Oaklands", id: "subc_Oaklands", key: 11288 },
      { label: "Rockland", id: "subc_Rockland", key: 11289 },
      { label: "Victoria West", id: "subc_Victoria West", key: 11290 }
    ]
  },
  { id: "city_Pitt Meadows", label: "Pitt Meadows", key: 2891, children: [] }
]
const sFraserOptions = [
  { text: "Surrey", labelFor: "surrey", value: "2887" },
  { text: "Langley (Township)", labelFor: "langley_township", value: "2879" },
  { text: "Langley (City)", labelFor: "langley_city", value: "3556" },
  { text: "Abbotsford", labelFor: "abbotsford", value: "2876" },
  { text: "Delta", labelFor: "delta", value: "2898" },
  { text: "Mission", labelFor: "mission", value: "3609" },
  { text: "White Rock", labelFor: "white_rock", value: "2897" },
  { text: "Chiliwack", labelFor: "chiliwack", value: "3610" },
]
  .sort((a, b) => a.text.localeCompare(b.text))
  .reduce((acc, curr) => {
    acc.push(curr);
    return acc;
  }, []);
const torontoCities = [
  { text: "Ottawa", label: "Ottawa", id: "city_Ottawa", value: "23528" },
  { text: "Montreal", label: "Montreal", id: "city_Montreal", value: "23526" },
  {
    text: "Toronto",
    label: "Toronto",
    id: "city_Toronto",
    value: "23495",
    children: [
      { text: "Etobicoke North (1)", label: "Etobicoke North (1)", id: "subc_Etobicoke North", value: "23501" },
      { text: "Etobicoke Centre (2)", label: "Etobicoke Centre (2)", id: "subc_Etobicoke Centre", value: "23502" },
      { text: "Etobicoke-Lakeshore (3)", label: "Etobicoke-Lakeshore (3)", id: "subc_Etobicoke-Lakeshore", value: "23503" },
      { text: "Parkdale-High Park (4)", label: "Parkdale-High Park (4)", id: "subc_Parkdale-High Park", value: "23504" },
      { text: "York South-Weston (5)", label: "York South-Weston (5)", id: "subc_York South-Weston", value: "23505" },
      { text: "York Centre (6)", label: "York Centre (6)", id: "subc_York Centre", value: "23506" },
      { text: "Humber River-Black Creek (7)", label: "Humber River-Black Creek (7)", id: "subc_Humber River-Black Creek", value: "23507" },
      { text: "Eglinton-Lawrence (8)", label: "Eglinton-Lawrence (8)", id: "subc_Eglinton-Lawrence", value: "23508" },
      { text: "Davenport (9)", label: "Davenport (9)", id: "subc_Davenport", value: "23509" },
      { text: "Spadina-Fort York (10)", label: "Spadina-Fort York (10)", id: "subc_Spadina-Fort York", value: "23510" },
      { text: "University-Rosedale (11)", label: "University-Rosedale (11)", id: "subc_University-Rosedale", value: "23511" },
      { text: "Toronto-St. Paul’s (12)", label: "Toronto-St. Paul’s (12)", id: "subc_Toronto-St. Paul’s", value: "23512" },
      { text: "Toronto Centre (13)", label: "Toronto Centre (13)", id: "subc_Toronto Centre", value: "23513" },
      { text: "Toronto-Danforth (14)", label: "Toronto-Danforth (14)", id: "subc_Toronto-Danforth", value: "23514" },
      { text: "Don Valley West (15)", label: "Don Valley West (15)", id: "subc_Don Valley West", value: "23515" },
      { text: "Don Valley East (16)", label: "Don Valley East (16)", id: "subc_Don Valley East", value: "23516" },
      { text: "Don Valley North (17)", label: "Don Valley North (17)", id: "subc_Don Valley North", value: "23517" },
      { text: "Willowdale (18)", label: "Willowdale (18)", id: "subc_Willowdale", value: "23518" },
      { text: "Beaches-East York (19)", label: "Beaches-East York (19)", id: "subc_Beaches-East York", value: "23519" },
      { text: "Scarborough Southwest (20)", label: "Scarborough Southwest (20)", id: "subc_Scarborough Southwest", value: "23520" },
      { text: "Scarborough Centre (21)", label: "Scarborough Centre (21)", id: "subc_Scarborough Centre", value: "23521" },
      { text: "Scarborough-Agincourt (22)", label: "Scarborough-Agincourt (22)", id: "subc_Scarborough-Agincourt", value: "23522" },
      { text: "Scarborough North (23)", label: "Scarborough North (23)", id: "subc_Scarborough North", value: "23523" },
      { text: "Scarborough-Guildwood (24)", label: "Scarborough-Guildwood (24)", id: "subc_Scarborough-Guildwood", value: "23524" },
      { text: "Scarborough-Rouge Park (25)", label: "Scarborough-Rouge Park (25)", id: "subc_Scarborough-Rouge Park", value: "23525" }
    ]
  },
];
const nFraserOptions = [
  { text: "Burnaby", labelFor: "burnaby", value: "2873" },
  { text: "Coquitlam", labelFor: "coquitlam", value: "2874" },
  { text: "Pemberton", labelFor: "pemberton", value: "25865" },
  { text: "Richmond", labelFor: "richmond", value: "2877" },
  { text: "North Vancouver (City)", labelFor: "north_van_city", value: "2949" },
  { text: "New Westminster", labelFor: "new_westminster", value: "2889" },
  {
    text: "North Vancouver (District)",
    labelFor: "north_vancouver_district",
    value: "2950",
  },
  { text: "West Vancouver", labelFor: "west_vancouver", value: "2896" },
  { text: "Port Coquitlam", labelFor: "port_coquitlam", value: "2892" },
  { text: "Port Moody", labelFor: "port_moody", value: "2893" },
  { text: "Squamish", labelFor: "squamish", value: "2894" },
  { text: "Vancouver", labelFor: "vancouver", value: "2895" },
  { text: "Van W (Musqueam)", labelFor: "van_w_musqueam", value: "25870" },
  { text: "Van W (Sen̓áḵw)", labelFor: "van_w_senakw", value: "25871" },
  { text: "Maple Ridge", labelFor: "maple_ridge", value: "2888" },
  { text: "Pitt Meadows", labelFor: "pitt_meadows", value: "2891" },
  {
    text: "Uni. Endow. Lands",
    labelFor: "university_endowment_lands",
    value: "3557",
  },
  { text: "UBC Campus", labelFor: "ubc_campus", value: "21879" },
  { text: "Chancellor Place", labelFor: "ubc_chancellor_place", value: "25834" },
  { text: "East Campus Neighbourhood", labelFor: "ubc_east_campus_neighbourhood", value: "25835" },
  { text: "Hampton Place", labelFor: "ubc_hampton_place", value: "25836" },
  { text: "Hawthorne Place", labelFor: "ubc_hawthorne_place", value: "25837" },
  { text: "North Campus Area", labelFor: "ubc_north_campus_area", value: "25839" },
  { text: "University Boulevard Area", labelFor: "ubc_university_boulevard_area", value: "25840" },
  { text: "Wesbrook Place", labelFor: "ubc_wesbrook_place", value: "25838" },
  { labelFor: "city_Duncan_cni", text: "Duncan", value: 21880 },
  { labelFor: "city_Castlegar_kt", text: "Castlegar", value: 23994 },
  { labelFor: "city_Cranbrook_kt", text: "Cranbrook", value: 24002 },
  { labelFor: "city_Kimberley_kt", text: "Kimberley", value: 24003 },
  { labelFor: "city_Nelson_kt", text: "Nelson", value: 23982 },
  { labelFor: "city_Revelstoke", text: "Revelstoke", value: 21860 },
]

const RAW_ALBERTA_CITIES = [
  {
    id: "reg_Alberta",
    label: "Alberta",
    key: 24077,
    children: [
      { id: "city_Airdrie", label: "Airdrie", key: 23460 },
      { id: "city_Brooks", label: "Brooks", key: 23461 },
      { id: "city_Calgary", label: "Calgary", key: 23462 },
      { id: "city_Camrose", label: "Camrose", key: 23463 },
      { id: "city_Canmore", label: "Canmore", key: 23479 },
      { id: "city_Chestermere", label: "Chestermere", key: 23464 },
      { id: "city_Cold Lake", label: "Cold Lake", key: 23465 },
      { id: "city_Edmonton", label: "Edmonton", key: 23466 },
      { id: "city_Fort Saskatchewan", label: "Fort Saskatchewan", key: 23467 },
      { id: "city_Grande Prairie", label: "Grande Prairie", key: 23468 },
      { id: "city_Lacombe", label: "Lacombe", key: 23469 },
      { id: "city_Leduc", label: "Leduc", key: 23470 },
      { id: "city_Lethbridge", label: "Lethbridge", key: 23471 },
      { id: "city_Lloydminster", label: "Lloydminster", key: 23472 },
      { id: "city_Medicine_Hat", label: "Medicine Hat", key: 23473 },
      { id: "city_Red Deer", label: "Red Deer", key: 23474 },
      { id: "city_Spruce Grove", label: "Spruce Grove", key: 23475 },
      { id: "city_St Albert", label: "St. Albert", key: 23476 },
      { id: "city_Wetaskiwin", label: "Wetaskiwin", key: 23477 }
    ]
  }
].sort((a, b) => a.text.localeCompare(b.text))
  .reduce((acc, curr) => {
    acc.push(curr);
    return acc;
  }, []);

const vanCities = [
  { value: "city_Saanich (Central)", text: "Saanich (Central)", key: 21141 },
  { value: "city_Colwood", text: "Colwood", key: 21142 },
  { value: "city_Esquimalt", text: "Esquimalt", key: 21143 },
  { value: "city_Highlands", text: "Highlands", key: 21144 },
  { value: "city_Langford", text: "Langford", key: 21145 },
  { value: "city_Nanaimo", text: "Nanaimo", key: 21192 },
  { value: "Saanich (North)", text: "Saanich (North)", key: 21146 },
  { value: "city_Oak Bay", text: "Oak Bay", key: 21147 },
  { value: "city_Parksville", text: "Parksville", key: 21592 },
  { value: "city_Saanich", text: "Saanich", key: 21148 },
  { value: "city_Salt Spring Island", text: "Salt Spring Island", key: 21191 },
  { value: "city_Sidney", text: "Sidney", key: 21149 },
  { value: "city_Sooke", text: "Sooke", key: 21150 },
  { value: "city_View Royal", text: "View Royal", key: 21190 },
  { value: "city_Victoria", text: "Victoria", key: 11257 },
  { value: "city_Campbell River", text: "Campbell River", key: 21881 },
  { value: "city_Comox", text: "Comox", key: 23897 },
  { value: "city_Cumberland", text: "Cumberland", key: 23952 },
  { value: "city_Courtney", text: "Courtney", key: 23893 },
  { value: "city_Duncan", text: "Duncan", key: 23428 },
  { value: "city_Ladysmith", text: "Ladysmith", key: 23899 },
  { value: "city_North Cowichan", text: "North Cowichan", key: 23894 },
  { value: "city_Port Alberni", text: "Port Alberni", key: 23895 },
];
const okaCities = [
  { id: "city_Okanagan_Falls", label: "Okanagan Falls", key: 25788 },
  { value: "city_Kamloops", text: "Kamloops", key: 21878 },
  { value: "city_Kelowna", text: "Kelowna", key: 21185 },
  { value: "city_Osoyoos", text: "Osoyoos", key: 21188 },
  { value: "city_Penticton", text: "Penticton", key: 21183 },
  { value: "city_Princeton", text: "Princeton", key: 21187 },
  { value: "city_Vernon", text: "Vernon", key: 21184 },
  { value: "city_West Kelowna", text: "West Kelowna", key: 21186 },
  { value: "city_Lake Country", text: "Lake Country", key: 21877 },
  { value: "city_Westbank", text: "Westbank", key: 23436 },
  { value: "city_Salmon Arm", text: "Salmon Arm", key: 23429 },
  { value: "city_Armstrong", text: "Armstrong", key: 24032 },
  { value: "city_Sicamous", text: "Sicamous", key: 23998 },
  { value: "city_Peachland", text: "Peachland", key: 21228 },
  { value: "city_Oliver", text: "Oliver", key: 24041 },
  { value: "city_Summerland", text: "Summerland", key: 23648 },
];

const EAST_COAST_CITIES = [
  {
    id: "reg_Ontario",
    label: "Ontario",
    key: 24072,
    children: [
      { id: "city_Brampton", label: "Brampton", key: 23649 },
      { id: "city_Cambridge", label: "Cambridge", key: 23655 },
      { id: "city_Guelph", label: "Guelph", key: 23791 },
      { id: "city_Hamilton", label: "Hamilton", key: 23643 },
      { id: "city_Kitchener", label: "Kitchener", key: 23650 },
      { id: "city_London", label: "London", key: 23651 },
      { id: "city_Markham", label: "Markham", key: 23652 },
      { id: "city_Mississauga", label: "Mississauga", key: 23530 },
      { id: "city_Ottawa", label: "Ottawa", key: 23528 },
      { id: "city_Pickering", label: "Pickering", key: 23663 },
      { id: "city_Toronto", label: "Toronto", key: 23495 },
      { id: "city_Vaughan", label: "Vaughan", key: 23653 },
      { id: "city_Waterloo", label: "Waterloo", key: 23647 },
      { id: "city_Windsor", label: "Windsor", key: 23654 }
    ]
  },
  {
    id: "reg_Quebec",
    label: "Quebec",
    key: 24075,
    children: [
      { id: "city_Montreal", label: "Montreal", key: 23527 },
    ]
  },
  {
    id: "reg_Nova Scotia",
    label: "Nova Scotia",
    key: 24076,
    children: [
      { id: "city_Halifax", label: "Halifax", key: 23641 },
    ]
  }
];

const ONTARIO_CITIES = [
  { text: "Pickering", labelFor: "pickering", value: "23663" },
  { text: "Guelph", labelFor: "guelph", value: "23791" },
  { text: "Cambridge", labelFor: "cambridge", value: "23655" },
  { text: "Hamilton", labelFor: "hamilton", value: "23643" },
  { text: "Halifax", labelFor: "halifax", value: "23641" },
  { text: "London", labelFor: "london", value: "23651" },
  { text: "Markham", labelFor: "markham", value: "23652" },
  { text: "Vaughan", labelFor: "vaughan", value: "23653" },
  { text: "Windsor", labelFor: "windsor", value: "23654" },
  { text: "Kitchener", labelFor: "kitchener", value: "23650" },
  { text: "Waterloo", labelFor: "waterloo", value: "23647" },
  { text: "Mississauga", labelFor: "mississauga", value: "23530" },
  { text: "Brampton", labelFor: "brampton", value: "23649" },
  { text: "Ottawa", labelFor: "ottawa", value: "23528" },
  { text: "Toronto", labelFor: "toronto", value: "23495" },
]
  .sort((a, b) => a.text.localeCompare(b.text))
  .reduce((acc, curr) => {
    acc.push(curr);
    return acc;
  }, []);
const QUEBEC_CITIES = [
  { text: "Montreal", labelFor: "montreal", value: "23527" },
  { text: "Quebec City", labelFor: "quebec_city", value: "23792" },
]
  .sort((a, b) => a.text.localeCompare(b.text))
  .reduce((acc, curr) => {
    acc.push(curr);
    return acc;
  }, []);

const BC_REGION_CITIES = [
  {
    id: "reg_Lower Mainland",
    label: "Lower Mainland",
    children: [
      {
        id: "subreg_Metro Vancouver",
        label: "Metro Vancouver",
        children: [
          {
            id: "city_Burnaby_mv",
            label: "Burnaby",
            key: 2873,
            children: [
              { label: "Lake City", id: "subc_Burnaby:Lake City_mv", key: 16743 },
              { label: "BainBridge", id: "subc_Burnaby:BainBridge_mv", key: 16753 },
              { label: "Big Bend", id: "subc_Burnaby:Big Bend_mv", key: 16752 },
              { label: "Brentwood", id: "subc_Burnaby:Brentwood_mv", key: 16751 },
              { label: "Broadview", id: "subc_Burnaby:Broadview_mv", key: 16750 },
              { label: "Capitol Hill", id: "subc_Burnaby:Capitol Hill_mv", key: 16749 },
              { label: "Central Administrative", id: "subc_Burnaby:Central Administrative_mv", key: 16748 },
              { label: "Discovery Place", id: "subc_Burnaby:Discovery Place_mv", key: 16747 },
              { label: "Edmonds", id: "subc_Burnaby:Edmonds_mv", key: 16746 },
              { label: "George Derby", id: "subc_Burnaby:George Derby_mv", key: 16745 },
              { label: "Hastings", id: "subc_Burnaby:Hastings_mv", key: 16744 },
              { label: "Lougheed", id: "subc_Burnaby:Lougheed_mv", key: 16742 },
              { label: "Metrotown", id: "subc_Burnaby:Metrotown_mv", key: 16741 },
              { label: "Montecito", id: "subc_Burnaby:Montecito_mv", key: 16740 },
              { label: "Rayside", id: "subc_Burnaby:Rayside_mv", key: 16739 },
              { label: "Royal Oak", id: "subc_Burnaby:Royal Oak_mv", key: 16738 },
              { label: "SFU", id: "subc_Burnaby:SFU_mv", key: 16737 },
              { label: "Sixth Street", id: "subc_Burnaby:Sixth Street_mv", key: 16736 }
            ]
          },
          {
            id: "city_Coquitlam_mv",
            label: "Coquitlam",
            key: 2874,
            children: [
              { label: "Burke Mountain (Upper Hyde Creek)", id: "subc_Coq:Burke_Upper_mv", key: 17221 },
              { label: "City Centre (C)", id: "subc_Coq:City_Centre_mv", key: 21101 },
              { label: "Burke Mountain (Partington Creek)", id: "subc_Coq:Burke_Part_mv", key: 17224 },
              { label: "Burke Mountain (Smiling Creek)", id: "subc_Coq:Burke_Smile_mv", key: 17223 },
              { label: "Mayfair/Pacific Reach", id: "subc_Coq:Mayfair_mv", key: 17222 },
              { label: "Northeast Coquitlam", id: "subc_Coq:Northeast_mv", key: 17220 },
              { label: "Burquitlam", id: "subc_Coq:Burquitlam_mv", key: 16754 },
              { label: "Hockaday Nestor", id: "subc_Coq:Hockaday_mv", key: 17219 },
              { label: "Burke Mountain (Lower Hyde Park)", id: "subc_Coq:Burke_Lower_mv", key: 16755 },
              { label: "Ranch Park", id: "subc_Coq:Ranch_Park_mv", key: 16756 },
              { label: "River Springs", id: "subc_Coq:River_Springs_mv", key: 16757 },
              { label: "Oxford Heights (C)", id: "subc_Coq:Oxford_mv", key: 16758 },
              { label: "Maillardville", id: "subc_Coq:Maillardville_mv", key: 16759 },
              { label: "Austin Heights", id: "subc_Coq:Austin_Heights_mv", key: 16760 },
              { label: "Chineside", id: "subc_Coq:Chineside_mv", key: 16761 },
              { label: "Birchland Manor (C)", id: "subc_Coq:Birchland_mv", key: 16762 },
              { label: "Coquitlam Town Centre", id: "subc_Coq:Town_Centre_mv", key: 16763 },
              { label: "Westwood Plateau", id: "subc_Coq:Westwood_mv", key: 16764 },
              { label: "Eagle Ridge", id: "subc_Coq:Eagle_Ridge_mv", key: 16765 },
              { label: "Mary Hill", id: "subc_Coq:Mary_Hill_mv", key: 16766 }
            ]
          },
          {
            id: "city_Delta_mv",
            label: "Delta",
            key: 2898,
            children: [
              { label: "Boundary Bay", id: "subc_Delta:Boundary_mv", key: 16698 },
              { label: "Ladner", id: "subc_Delta:Ladner_mv", key: 16695 },
              { label: "North Delta", id: "subc_Delta:North_mv", key: 16696 },
              { label: "Tsawwassen", id: "subc_Delta:Tsawwassen_mv", key: 16697 },
              { label: "Tsawwassen First Nation", id: "subc_Delta:TFN_mv", key: 23430 }
            ]
          },
          {
            id: "city_LangleyCity_mv",
            label: "Langley (City)",
            key: 3556,
            children: [
              { label: "Alice Brown", id: "subc_LCity:Alice_mv", key: 16685 },
              { label: "Douglas", id: "subc_LCity:Douglas_mv", key: 16682 },
              { label: "Blacklock", id: "subc_LCity:Blacklock_mv", key: 16684 },
              { label: "Nicomekl", id: "subc_LCity:Nicomekl_mv", key: 16681 },
              { label: "Simonds", id: "subc_LCity:Simonds_mv", key: 16683 },
              { label: "Uplands", id: "subc_LCity:Uplands_mv", key: 16686 }
            ]
          },
          {
            id: "city_LangleyTownship_mv",
            label: "Langley (Township)",
            key: 2879,
            children: [
              { label: "Walnut Grove", id: "subc_LTown:Walnut_mv", key: 16677 },
              { label: "Brookswood / Fernridge", id: "subc_LTown:Brookswood_mv", key: 16671 },
              { label: "Gloucester", id: "subc_LTown:Gloucester_mv", key: 16673 },
              { label: "Murrayville", id: "subc_LTown:Murrayville_mv", key: 16674 },
              { label: "Northwest Langley", id: "subc_LTown:Northwest_mv", key: 16675 },
              { label: "Rural", id: "subc_LTown:Rural_mv", key: 16676 },
              { label: "Willoughby Hts", id: "subc_LTown:Willoughby_mv", key: 16678 },
              { label: "Willowbrook", id: "subc_LTown:Willowbrook_mv", key: 16679 },
              { label: "Aldergrove", id: "subc_LTown:Aldergrove_mv", key: 16670 },
              { label: "Fort Langley", id: "subc_LTown:Fort_Langley_mv", key: 16672 }
            ]
          },
          {
            id: "city_MapleRidge_mv",
            label: "Maple Ridge",
            key: 2888,
            children: [
              { label: "Albion", id: "subc_Maple:Albion_mv", key: 19067 },
              { label: "Allco", id: "subc_Maple:Allco_mv", key: 19068 },
              { label: "Alouette", id: "subc_Maple:Alouette_mv", key: 19069 },
              { label: "Blue Mountain", id: "subc_Maple:Blue_mv", key: 19070 },
              { label: "Central Maple Ridge", id: "subc_Maple:Central_mv", key: 19071 },
              { label: "Cottonwood", id: "subc_Maple:Cottonwood_mv", key: 19072 },
              { label: "East Maple Ridge", id: "subc_Maple:East_mv", key: 19073 },
              { label: "Hammond", id: "subc_Maple:Hammond_mv", key: 19074 },
              { label: "Rothsay", id: "subc_Maple:Rothsay_mv", key: 19075 },
              { label: "Ruskin", id: "subc_Maple:Ruskin_mv", key: 19076 },
              { label: "Silver Valley", id: "subc_Maple:Silver_Valley_mv", key: 19077 },
              { label: "Smith", id: "subc_Maple:Smith_mv", key: 19078 },
              { label: "South Alouette", id: "subc_Maple:South_Alouette_mv", key: 19079 },
              { label: "Spilsbury", id: "subc_Maple:Spilsbury_mv", key: 19080 },
              { label: "Thornhill", id: "subc_Maple:Thornhill_mv", key: 19081 },
              { label: "Town Centre", id: "subc_Maple:Town_Centre_mv", key: 19082 },
              { label: "Websters Corners", id: "subc_Maple:Websters_mv", key: 19083 },
              { label: "West Maple Ridge", id: "subc_Maple:West_mv", key: 19084 },
              { label: "Whispering Falls", id: "subc_Maple:Whispering_mv", key: 19085 },
              { label: "Whonnock", id: "subc_Maple:Whonnock_mv", key: 19086 },
              { label: "Yennadon", id: "subc_Maple:Yennadon_mv", key: 19087 }
            ]
          },
          {
            id: "city_NewWest_mv",
            label: "New Westminster",
            key: 2889,
            children: [
              { label: "Queensborough", id: "subc_NW:Queensborough_mv", key: 17522 },
              { label: "Connaught Heights", id: "subc_NW:Connaught_mv", key: 17523 },
              { label: "West End", id: "subc_NW:West_End_mv", key: 17524 },
              { label: "Kelvin", id: "subc_NW:Kelvin_mv", key: 17525 },
              { label: "Brow of the Hill", id: "subc_NW:Brow_mv", key: 17526 },
              { label: "Glenbrooke North", id: "subc_NW:Glenbrooke_N_mv", key: 17527 },
              { label: "Queen's Park", id: "subc_NW:Queens_Park_mv", key: 17528 },
              { label: "Victory Heights", id: "subc_NW:Victory_mv", key: 17529 },
              { label: "Sapperton", id: "subc_NW:Sapperton_mv", key: 17530 },
              { label: "North Arm South", id: "subc_NW:NASouth_mv", key: 17531 },
              { label: "North Arm North", id: "subc_NW:NANorth_mv", key: 17532 },
              { label: "Uptown", id: "subc_NW:Uptown_mv", key: 17533 },
              { label: "Downtown", id: "subc_NW:Downtown_mv", key: 17534 },
              { label: "Glenbrooke South", id: "subc_NW:Glenbrooke_S_mv", key: 17535 },
              { label: "Brunette Creek", id: "subc_NW:Brunette_mv", key: 17536 }
            ]
          },
          {
            id: "city_NorthVanCity_mv",
            label: "North Vancouver (City)",
            key: 2949,
            children: [
              { label: "Mahon", id: "subc_NVCity:Mahon_mv", key: 17857 },
              { label: "Central Lonsdale", id: "subc_NVCity:Central_mv", key: 17854 },
              { label: "Lower Lonsdale", id: "subc_NVCity:Lower_mv", key: 17856 },
              { label: "Moodyville", id: "subc_NVCity:Moodyville_mv", key: 17859 }
            ]
          },
          {
            id: "city_NorthVanDist_mv",
            label: "North Vancouver (District)",
            key: 2950,
            children: [
              { label: "Lynn Creek", id: "subc_NVDist:Lynn_mv", key: 17213 },
              { label: "Deep Cove", id: "subc_NVDist:Deep_Cove_mv", key: 17210 },
              { label: "Lynn Valley", id: "subc_NVDist:Lynn_Valley_mv", key: 17214 }
            ]
          },
          {
            id: "city_PittMeadows_mv",
            label: "Pitt Meadows",
            key: 2891,
            children: []
          },
          {
            id: "city_PortCoquitlam_mv",
            label: "Port Coquitlam",
            key: 2892,
            children: [
              { label: "Birchland Manor", id: "subc_PortCoq:Birchland_mv", key: 19794 },
              { label: "Central Pt Coquitlam", id: "subc_PortCoq:Central_mv", key: 19796 },
              { label: "Citadel PQ", id: "subc_PortCoq:Citadel_mv", key: 19798 },
              { label: "Glenwood PQ", id: "subc_PortCoq:Glenwood_mv", key: 19793 },
              { label: "Lincoln Park PQ", id: "subc_PortCoq:Lincoln_mv", key: 19791 },
              { label: "Lower Mary Hill", id: "subc_PortCoq:LowerMaryHill_mv", key: 19797 },
              { label: "Oxford Heights", id: "subc_PortCoq:Oxford_mv", key: 19790 },
              { label: "Riverwood", id: "subc_PortCoq:Riverwood_mv", key: 19795 },
              { label: "Woodland Acres PQ", id: "subc_PortCoq:Woodland_mv", key: 19792 }
            ]
          },
          {
            id: "city_PortMoody_mv",
            label: "Port Moody",
            key: 2893,
            children: [
              { label: "Heritage Mountain", id: "subc_PM:Heritage_mv", key: 19054 },
              { label: "Moody Centre", id: "subc_PM:Moody_mv", key: 19059 },
              { label: "Inlet Centre", id: "subc_PM:Inlet_mv", key: 19057 }
            ]
          },
          {
            id: "city_Richmond_mv",
            label: "Richmond",
            key: 2877,
            children: [
              { label: "Blundell", id: "subc_Rich:Blundell_mv", key: 18833 },
              { label: "City Centre", id: "subc_Rich:City_mv", key: 18836 },
              { label: "Steveston", id: "subc_Rich:Steveston_mv", key: 18841 },
              { label: "Thompson", id: "subc_Rich:Thompson_mv", key: 18842 }
            ]
          },
          {
            id: "city_Surrey",
            label: "Surrey",
            key: 2887,
            children: [
              { label: "Cloverdale", id: "subc_Cloverdale", key: 11164 },
              { label: "Fleetwood", id: "subc_Fleetwood", key: 11161 },
              { label: "Guildford", id: "subc_Guildford", key: 11162 },
              { label: "Newton", id: "subc_Newton", key: 11165 },
              { label: "South Surrey", id: "subc_South Surrey", key: 11159 },
              { label: "Whalley", id: "subc_Whalley", key: 11163 }
            ]
          },
          {
            label: "University Endowment Lands", id: "subc_Van:UEL_mv", key: 21171
          },
          {
            id: "city_UBC Campus_mv",
            label: "UBC Campus",
            key: 21879,
            children: [
              { label: "Chancellor Place", id: "subc_UBC:Chancellor_mv", key: 25834 },
              { label: "East Campus Neighbourhood", id: "subc_UBC:East Campus_mv", key: 25835 },
              { label: "Hampton Place", id: "subc_UBC:Hampton_mv", key: 25836 },
              { label: "Hawthorne Place", id: "subc_UBC:Hawthorne_mv", key: 25837 },
              { label: "North Campus Area", id: "subc_UBC:North Campus_mv", key: 25839 },
              { label: "University Boulevard Area", id: "subc_UBC:University Boulevard_mv", key: 25840 },
              { label: "Wesbrook Place", id: "subc_UBC:Wesbrook_mv", key: 25838 }
            ]
          },
          {
            id: "city_Vancouver_mv",
            label: "Vancouver",
            key: 2895,
            children: [
              { label: "Van E (Grandview-Woodland)", id: "subc_Van E (Grandview-Woodland)_mv", key: 16718 },
              { label: "Van E (Hastings-Sunrise)", id: "subc_Van E (Hastings-Sunrise)_mv", key: 16719 },
              { label: "Van E (Kensington-Cedar Cottage)", id: "subc_Van E (Kensington-Cedar Cottage)_mv", key: 16720 },
              { label: "Van E (Killarney)", id: "subc_Van E (Killarney)_mv", key: 16722 },
              { label: "Van E (Mount Pleasant)", id: "subc_Van E (Mount Pleasant)_mv", key: 16725 },
              { label: "Van E (Renfrew-Collingwood)", id: "subc_Van E (Renfrew-Collingwood)_mv", key: 16727 },
              { label: "Van E (Strathcona)", id: "subc_Van E (Strathcona)_mv", key: 16731 },
              { label: "Van E (Sunset)", id: "subc_Van E (Sunset)_mv", key: 16732 },
              { label: "Van E (Victoria-Fraserview)", id: "subc_Van E (Victoria-Fraserview)_mv", key: 16733 },
              { label: "Van E / W (Riley Park - Little Mountain)", id: "subc_Van E / W (Riley Park - Little Mountain)_mv", key: 16728 },
              { label: "Van W (Arbutus Ridge)", id: "subc_Van W (Arbutus Ridge)_mv", key: 16714 },
              { label: "Van W (Dunbar-Southlands)", id: "subc_Van W (Dunbar-Southlands)_mv", key: 16716 },
              { label: "Van W (Fairview)", id: "subc_Van W (Fairview)_mv", key: 16717 },
              { label: "Van W (Kerrisdale)", id: "subc_Van W (Kerrisdale)_mv", key: 16721 },
              { label: "Van W (Kitsilano)", id: "subc_Van W (Kitsilano)_mv", key: 16723 },
              { label: "Van W (Marpole)", id: "subc_Van W (Marpole)_mv", key: 16724 },
              { label: "Van W (Musqueam)", id: "subc_Van W (Musqueam)_mv", key: 25870 },
              { label: "Van W (Oakridge)", id: "subc_Van W (Oakridge)_mv", key: 16726 },
              { label: "Van W (Sen̓áḵw)", id: "subc_Van W (Sen̓áḵw)_mv", key: 25871 },
              { label: "Van W (Shaughnessy)", id: "subc_Van W (Shaughnessy)_mv", key: 16729 },
              { label: "Van W (South Cambie)", id: "subc_Van W (South Cambie)_mv", key: 16730 },
              { label: "Van W (West Point Grey)", id: "subc_Van W (West Point Grey)_mv", key: 16735 },
              { label: "Van Downtown", id: "subc_Van Downtown_mv", key: 16715 },
              { label: "Van Downtown (West End)", id: "subc_Van Downtown (West End)_mv", key: 16734 },
              { label: "University Endowment Lands", id: "subc_University Endowment Lands_mv", key: 21171 }
            ]
          },
          {
            id: "city_WestVan_mv",
            label: "West Vancouver",
            key: 2896,
            children: [
              { label: "Ambleside", id: "subc_WVan:Ambleside_mv", key: 18495 },
              { label: "British Properties", id: "subc_WVan:British_mv", key: 18497 },
              { label: "Dundarave", id: "subc_WVan:Dundarave_mv", key: 18500 },
              { label: "Horseshoe Bay", id: "subc_WVan:Horseshoe_mv", key: 18503 },
              { label: "Lions Gate", id: "subc_WVan:Lions Gate", key: 21859 },
            ]
          },
          {
            id: "city_WhiteRock_mv",
            label: "White Rock",
            key: 2897,
            children: []
          }
        ]
      },
      {
        id: "subreg_Fraser Valley",
        label: "Fraser Valley",
        children: [
          { id: "city_Abbotsford_fv", label: "Abbotsford", key: 2876 },
          { id: "city_Chilliwack_fv", label: "Chilliwack", key: 3610 },
          { id: "city_Mission_fv", label: "Mission", key: 3609 }
        ]
      }
    ]
  },
  {
    id: "reg_Coastal BC",
    label: "Coastal BC",
    children: [
      {
        id: "reg_Sea to Sky",
        label: "Sea to Sky",
        children: [
          {
            id: "city_Pemberton",
            label: "Pemberton",
            key: 25865,
          },
          {
            id: "city_Squamish_sts",
            label: "Squamish",
            key: 2894,
            children: [
              { label: "Downtown Squamish", id: "subc_Squamish:Downtown_sts", key: 21593 },
              { label: "Paradise Valley", id: "subc_Squamish:Paradise_sts", key: 20618 },
              { label: "Tantalus", id: "subc_Squamish:Tantalus_sts", key: 20619 },
              { label: "Brackendale", id: "subc_Squamish:Brackendale_sts", key: 20620 },
              { label: "Garibaldi Estates", id: "subc_Squamish:Garibaldi_sts", key: 20621 },
              { label: "Squamish South", id: "subc_Squamish:South_sts", key: 20624 },
              { label: "Brennan Park/ Loggers Lane", id: "subc_Squamish:Brennan_sts", key: 20622 },
              { label: "Valleycliffe & Hospital Hill", id: "subc_Squamish:Valleycliffe_sts", key: 20623 },
              { label: "North Yards", id: "subc_Squamish:NorthYards_sts", key: 20625 },
              { label: "Dentville", id: "subc_Squamish:Dentville_sts", key: 20626 }
            ]
          },
          { id: "city_Whistler", label: "Whistler", key: 24092 }
        ]
      },
      {
        id: "reg_Sunshine_Coast",
        label: "Sunshine Coast",
        children: [
          { id: "city_Gibsons_sc", label: "Gibsons", key: 24066 },
          { id: "city_Sechelt_sc", label: "Sechelt", key: 24065 },
          { id: "city_Powell_River_sc", label: "Powell River", key: 23898 }
        ]
      }
    ]
  },
  {
    id: "reg_Vancouver Island",
    label: "Vancouver Island",
    children: [
      {
        id: "reg_Greater Victoria",
        label: "Greater Victoria",
        children: [
          { id: "city_Colwood_vic", label: "Colwood", key: 21142 },
          { id: "city_Esquimalt_vic", label: "Esquimalt", key: 21143 },
          { id: "city_Langford_vic", label: "Langford", key: 21145 },
          { id: "city_OakBay_vic", label: "Oak Bay", key: 21147 },
          {
            id: "city_Saanich_vic",
            label: "Saanich",
            key: 21148,
            children: [
              { label: "Tillicum", id: "subc_Saanich:Tillicum_vic", key: 23128 },
              { label: "Shelbourne", id: "subc_Saanich:Shelbourne_vic", key: 21882 },
              { label: "Saanich Core", id: "subc_Saanich:Core_vic", key: 23126 },
              { label: "Gordon Head", id: "subc_Saanich:Gordon_vic", key: 23129 },
              { label: "Royal Oak", id: "subc_Saanich:Royal_vic", key: 23122 }
            ]
          },
          { id: "city_Saanich (Central)_vic", label: "Saanich (Central)", key: 21141 },
          { id: "city_Saanich (North)_vic", label: "Saanich (North)", key: 21146 },
          { id: "city_Sidney_vic", label: "Sidney", key: 21149 },
          { id: "city_Sooke_vic", label: "Sooke", key: 21150 },
          {
            id: "city_Victoria_vic",
            label: "Victoria",
            key: 11257,
            children: [
              { label: "Burnside", id: "subc_Vic:Burnside_vic", key: 11278 },
              { label: "Downtown", id: "subc_Vic:Downtown_vic", key: 11279 },
              { label: "Fairfield", id: "subc_Vic:Fairfield_vic", key: 11280 },
              { label: "Fernwood", id: "subc_Vic:Fernwood_vic", key: 11281 },
              { label: "James Bay", id: "subc_Vic:James_Bay_vic", key: 11285 },
              { label: "Rockland", id: "subc_Vic:Rockland_vic", key: 11289 }
            ]
          },
          { id: "city_ViewRoyal_vic", label: "View Royal", key: 21190 }
        ]
      },
      {
        id: "reg_Central North Vancouver Island",
        label: "Central & North Vancouver Island",
        children: [
          { id: "city_Campbell River_cni", label: "Campbell River", key: 21881 },
          { id: "city_Comox_cni", label: "Comox", key: 23897 },
          { id: "city_Courtenay_cni", label: "Courtenay", key: 23893 },
          { id: "city_Cumberland_cni", label: "Cumberland", key: 23952 },
          { id: "city_Duncan_cni", label: "Duncan", key: 21880 },
          { id: "city_Ladysmith_cni", label: "Ladysmith", key: 23899 },
          { id: "city_Nanaimo_cni", label: "Nanaimo", key: 21192 },
          { id: "city_North Cowichan_cni", label: "North Cowichan", key: 23894 },
          { id: "city_Parksville_cni", label: "Parksville", key: 21592 },
          { id: "city_Port Alberni_cni", label: "Port Alberni", key: 23895 }
        ]
      }
    ]
  },
  {
    id: "reg_Interior BC",
    label: "Interior BC",
    children: [
      {
        id: "reg_Okanagan",
        label: "Okanagan",
        children: [
          { id: "city_Okanagan_Falls", label: "Okanagan Falls", key: 25788 },
          { id: "city_Kelowna_ok", label: "Kelowna", key: 21185 },
          { id: "city_Lake Country_ok", label: "Lake Country", key: 21877 },
          { id: "city_Oliver_ok", label: "Oliver", key: 24041 },
          { id: "city_Osoyoos_ok", label: "Osoyoos", key: 21188 },
          { id: "city_Peachland_ok", label: "Peachland", key: 21228 },
          { id: "city_Penticton_ok", label: "Penticton", key: 21183 },
          {
            id: "city_Princeton_ok",
            label: "Princeton",
            key: 21187,
            children: [
              { label: "1st Bench", id: "subc_Pr:1st_ok", key: 21205 },
              { label: "2nd Bench", id: "subc_Pr:2nd_ok", key: 21206 },
              { label: "3rd Bench", id: "subc_Pr:3rd_ok", key: 21207 },
              { label: "Airport", id: "subc_Pr:Airport_ok", key: 21208 },
              { label: "Allison Flats", id: "subc_Pr:Allison_ok", key: 21209 },
              { label: "Downtown Core", id: "subc_Pr:Core_ok", key: 21211 },
              { label: "Westridge Heights", id: "subc_Pr:Westridge_ok", key: 21216 }
            ]
          },
          { id: "city_Summerland_ok", label: "Summerland", key: 23648 },
          { id: "city_Vernon_ok", label: "Vernon", key: 24034 },
          { id: "city_West Kelowna_ok", label: "West Kelowna", key: 21186 }
        ]
      },
      {
        id: "reg_Thompson Nicola",
        label: "Thompson-Nicola",
        children: [
          { id: "city_Kamloops_tn", label: "Kamloops", key: 21878 }
        ]
      },
      {
        id: "reg_Columbia Shuswap",
        label: "Columbia-Shuswap",
        children: [
          { id: "city_Revelstoke_cs", label: "Revelstoke", key: 21860 },
          { id: "city_Salmon Arm_cs", label: "Salmon Arm", key: 23429 },
          { id: "city_Sicamous_cs", label: "Sicamous", key: 23998 }
        ]
      },
      {
        id: "reg_Kootenay",
        label: "Kootenay",
        children: [
          { id: "city_Castlegar_kt", label: "Castlegar", key: 23994 },
          { id: "city_Cranbrook_kt", label: "Cranbrook", key: 24002 },
          { id: "city_Kimberley_kt", label: "Kimberley", key: 24003 },
          { id: "city_Nelson_kt", label: "Nelson", key: 23982 }
        ]
      }
    ]
  },
];

// BC region city keys for search payloads. Mirrors the BC branch of the
// 'form.region' watcher in ListSearch.vue (line 447): flatten the four BC
// source lists into a single key list, dropping duplicates so a city that
// appears in more than one list is only sent once.
const BC_REGION_CITIES_KEYS = [
  ...new Set([
    ...sFraserOptions.map((c) => Number(c.value)),
    ...nFraserOptions.map((c) => Number(c.value)),
    ...vanCities.map((c) => c.key),
    ...okaCities.map((c) => c.key),
  ]),
];

// Surrey's sub-community keys (Cloverdale, Whalley, South Surrey, ...). Units
// are tagged to one of these rather than to Surrey itself, and the rental
// report endpoint (get_rental_mls_list_mid) matches tids flatly with no
// taxonomy-hierarchy expansion — so the parent key 2887 alone misses them.
// Only send these where that flat matching applies; the regular search
// endpoints expand the hierarchy themselves. Derived from subCities so the
// two stay in sync.
const SURREY_SUB_KEYS = (
  subCities.find((c) => c.id === "city_Surrey") || { children: [] }
).children.map((c) => c.key);

// Curated mid list for the Investor Rental Report, which is the Investor Rental
// tab of the MLS unit report (MLSList.vue -> fetchInvestorData ->
// api/get_rental_mls_list_mid). A fixed list rather than a derived one: the
// report's scope was set by hand, so it is neither every BC parent key nor a
// full parent+children flatten. Two things to know before editing:
//   - Sub coverage is deliberately uneven. Some cities send every sub key
//     (Burnaby, Coquitlam, Maple Ridge, ...), others only a few (Richmond 4,
//     Port Moody 3) or the parent alone (Abbotsford, Chilliwack, Nanaimo,
//     Kelowna, ...). Because get_rental_mls_list_mid matches tids flatly with
//     no hierarchy expansion (see SURREY_SUB_KEYS above), a city whose subs
//     are absent here contributes only units tagged to the parent itself.
//   - 21 of these keys resolve to no node in subCities (17210, 17213, 17214,
//     17854, 17856, 17857, 17859, 23648, 23893-23899, 23952, 23998, 24034,
//     24041, 24065, 24066, 24092). They are grouped below under the city they
//     follow in the report URL this list came from.
// Grouped parent-first per city, in the order the report was built. 227 keys.
const INVESTOR_RENTAL_MIDS = [
  // Burnaby
  2873, 16743, 16753, 16752, 16751, 16750, 16749, 16748, 16747, 16746,
  16745, 16744, 16742, 16741, 16740, 16739, 16738, 16737, 16736,
  // Coquitlam
  2874, 17221, 21101, 17224, 17223, 17222, 17220, 16754, 17219, 16755,
  16756, 16757, 16758, 16759, 16760, 16761, 16762, 16763, 16764, 16765,
  16766,
  // Delta
  2898, 16698, 16695, 16696, 16697,
  // Tsawwassen First Nation
  23430,
  // Langley (City)
  3556, 16685, 16682, 16684, 16681, 16683, 16686,
  // Langley (Township)
  2879, 16677, 16671, 16673, 16674, 16675, 16676, 16678, 16679, 16670,
  16672,
  // Maple Ridge
  2888, 19067, 19068, 19069, 19070, 19071, 19072, 19073, 19074, 19075,
  19076, 19077, 19078, 19079, 19080, 19081, 19082, 19083, 19084, 19085,
  19086, 19087,
  // New Westminster
  2889, 17522, 17523, 17524, 17525, 17526, 17527, 17528, 17529, 17530,
  17531, 17532, 17533, 17534, 17535, 17536,
  // North Vancouver (City)
  2949, 17857, 17854, 17856, 17859,
  // North Vancouver (District)
  2950, 17213, 17210, 17214,
  // Pitt Meadows
  2891,
  // Port Moody
  2893, 19054, 19059, 19057,
  // Richmond
  2877, 18833, 18836, 18841, 18842,
  // Surrey
  2887, 11164, 11161, 11162, 11165, 11159, 11163, 21171,
  // Vancouver
  2895, 16718, 16719, 16720, 16722, 16725, 16727, 16731, 16732, 16714,
  16716, 16717, 16721, 16723, 16724, 16726, 16729, 16730, 16735, 16715,
  16734,
  // West Vancouver
  2896, 18495, 18497, 18500, 18503, 21859,
  // Abbotsford
  2876,
  // Chiliwack
  3610,
  // Mission
  3609,
  // Squamish
  2894, 21593, 20618, 20619, 20620, 20621, 20624, 20622, 20623, 20625,
  20626, 24092, 24066, 24065, 23898,
  // Colwood
  21142,
  // Esquimalt
  21143,
  // Langford
  21145,
  // Oak Bay
  21147,
  // Saanich
  21148, 23128, 21882, 23126, 23129, 23122,
  // Saanich (Central)
  21141,
  // Saanich (North)
  21146,
  // Sidney
  21149,
  // Sooke
  21150,
  // Victoria
  11257, 11278, 11279, 11280, 11281, 11285, 11289,
  // View Royal
  21190,
  // Campbell River
  21881, 23897, 23893, 23952,
  // Duncan
  21880, 23899,
  // Nanaimo
  21192, 23894,
  // Parksville
  21592, 23895,
  // Kelowna
  21185,
  // Lake Country
  21877, 24041,
  // Osoyoos
  21188,
  // Peachland
  21228,
  // Penticton
  21183,
  // Princeton
  21187, 21205, 21206, 21207, 21208, 21209, 21211, 21216, 23648, 24034,
  // West Kelowna
  21186,
  // Kamloops
  21878,
  // Revelstoke
  21860,
  // Salmon Arm
  23429, 23998,
];

function sortCities(data) {
  return data
    .map((city) => ({
      ...city,
      children: city.children.sort((a, b) => a.label.localeCompare(b.label)),
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
}

const sortedCities = sortCities(subCities);

export const getAlbertaCities = () => {
  const userStore = useUserStore();
  const user = userStore.current_user;

  if (user && user.role === 'admin') {
    return RAW_ALBERTA_CITIES;
  }

  return RAW_ALBERTA_CITIES.map(region => ({
    ...region,
    children: region.children.filter(ac =>
      ['Airdrie', 'Calgary', 'Edmonton', 'Canmore'].includes(ac.label)
    )
  }));
};

// Every taxonomy key in a city tree — each node plus its descendants. Views that
// scope a request to a whole region need this, so the flattening lives here
// instead of being repeated per view.
export const flattenCityKeys = (nodes) =>
  (nodes || []).reduce((keys, node) => {
    if (node.key != null) keys.push(node.key);
    else if (node.value != null) keys.push(Number(node.value));
    if (node.children) keys.push(...flattenCityKeys(node.children));
    return keys;
  }, []);

// Alberta keys the current user can see — getAlbertaCities() is role-filtered,
// so this must be called at request time rather than cached at module load.
export const getAlbertaCityKeys = () => flattenCityKeys(getAlbertaCities());

// Every city and neighbourhood the app knows, flattened to what one
// field_city_neighbourhood value needs: the taxonomy tid, and a path that tells
// two same-named neighbourhoods apart ("British Columbia › Metro Vancouver ›
// Burnaby › Edmonds"). The trees above are shaped for region filters, where a
// node only ever has to answer "is this key selected"; picking the single term a
// project sits in is a different question, and this is the only place that asks
// it.
//
// Region roots are skipped — depth 0 of each tree is a province or a filter
// grouping, not somewhere a project is. Cities keep their own entry even though
// they carry neighbourhoods: a project is routinely filed against the city
// before its neighbourhood is settled.
//
// Role-filtered through getAlbertaCities(), so call it at request time rather
// than caching the result at module load.
export const cityOptionList = () => {
  const options = [];
  const walk = (nodes, trail, depth) => {
    (nodes || []).forEach((node) => {
      const label = node.label || node.text || "";
      const raw = node.key != null ? node.key : node.value;
      const tid = raw == null || raw === "" ? null : Number(raw);
      const path = label ? trail.concat([label]) : trail;
      if (tid && depth > 0) options.push({ tid, label, path: path.join(" › ") });
      if (node.children) walk(node.children, path, depth + 1);
    });
  };
  walk(
    [
      { label: "British Columbia", children: BC_REGION_CITIES },
      ...getAlbertaCities(),
      ...EAST_COAST_CITIES,
      // sortedCities carries BC municipalities the region tree does not group
      // (Sooke, Nanaimo, Duncan …); Quebec is a flat { text, value } list.
      { label: "British Columbia", children: sortedCities },
      { label: "Quebec", children: QUEBEC_CITIES },
    ],
    [],
    0
  );
  // A term reachable from more than one tree keeps its first path — the region
  // trees are listed above in the order that names a place best.
  const seen = new Set();
  return options
    .filter((option) => !seen.has(option.tid) && seen.add(option.tid))
    .sort((a, b) => a.path.localeCompare(b.path));
};

/**
 * BC_REGION_CITIES with COASTAL BC NESTED UNDER LOWER MAINLAND, after Fraser
 * Valley — the arrangement the report pages show their City filter in.
 *
 *   British Columbia
 *     Lower Mainland
 *       Greater Vancouver / Metro Vancouver
 *       Fraser Valley
 *       Coastal BC        -> Sea to Sky, Sunshine Coast
 *     Vancouver Island
 *     Interior BC
 *
 * DISPLAY ONLY, AND A COPY. Nothing is renamed, nothing is dropped and the
 * source tree is not touched: `reg_Coastal BC`, `reg_Sea to Sky`, every
 * `city_` id and every taxonomy key keep their spelling, so a saved bookmark
 * still resolves and the pages that read BC_REGION_CITIES directly — the MLS
 * lists, ListingNew, the quarterly scope tree, which looks `reg_Coastal BC` up
 * at the top level — are unaffected. The filters that use this resolve a tick
 * by walking whatever tree they were given and collecting the `city_` labels
 * beneath it, so moving a branch moves its municipalities with it and needs no
 * other wiring.
 *
 * THE CONSEQUENCE IS DELIBERATE: ticking Lower Mainland here now takes Squamish,
 * Whistler, Pemberton and the Sunshine Coast with it, because they are inside
 * it. That is what the row means once Coastal BC sits in it.
 *
 * A TREE WITHOUT BOTH BRANCHES COMES BACK UNCHANGED — the Alberta and Eastern
 * Canada trees go through the same call sites.
 */
const bcCitiesCoastalUnderLowerMainland = (nodes) => {
  const tree = nodes || [];
  const lowerMainland = tree.find((n) => n && n.id === "reg_Lower Mainland");
  const coastal = tree.find((n) => n && n.id === "reg_Coastal BC");
  if (!lowerMainland || !coastal) return tree;
  return tree
    .filter((n) => n !== coastal)
    .map((n) =>
      n === lowerMainland
        ? { ...n, children: (n.children || []).concat([coastal]) }
        : n
    );
};

export {
  subCities,
  sortedCities,
  sFraserOptions,
  nFraserOptions,
  vanCities,
  okaCities,
  torontoCities,
  ONTARIO_CITIES,
  QUEBEC_CITIES,
  BC_REGION_CITIES,
  bcCitiesCoastalUnderLowerMainland,
  BC_REGION_CITIES_KEYS,
  SURREY_SUB_KEYS,
  INVESTOR_RENTAL_MIDS,
  EAST_COAST_CITIES
};
